import WatchService from '../services/watch.service'
import { handleCookieError } from '../utils/utils.js'
import router from '@/router'

export const watchModule = {
  namespaced: true,

  actions: {
    async watchService ({ commit }) {
      return WatchService.watchService().then(
        response => {
          return Promise.resolve(response)
        },
        error => {
          return handleCookieError(error, router)
        }
      )
    }
  }
}
